import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { haySesionActiva } from '../config/api';
import { rutaSelector } from '../rutas/rutasConsola';

/**
 * Wrapper de rutas protegidas.
 *
 * Comportamiento:
 *   1) Si no hay sesión (según el marcador no sensible `userRoles`, que escribe
 *      el login), redirige a `/` conservando la URL original en `state.from`
 *      para volver tras el login. No lee el access token: vive en una cookie
 *      httpOnly que JavaScript no puede leer, y la validación real la hace el
 *      backend en la primera petición (un 401 expulsa al login).
 *   2) Con sesión, renderiza los children.
 *
 * Roles opcionales:
 *   Si se pasa la prop `roles=['ROLE_ADMIN']`, además de la sesión se exige que
 *   `localStorage.userRoles` (array JSON) contenga al menos uno de ellos. Si
 *   no, redirige a `/bots` (en lugar de a login) para no expulsar al
 *   usuario logueado, pero sí evitar que vea la pantalla.
 */
function RequireAuth({ children, roles }) {
  const location = useLocation();

  if (!haySesionActiva()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (roles && roles.length > 0) {
    let userRoles = [];
    try {
      userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]');
      if (!Array.isArray(userRoles)) userRoles = [];
    } catch (_) {
      userRoles = [];
    }
    const ok = roles.some((r) => userRoles.includes(r));
    if (!ok) {
      return <Navigate to={rutaSelector()} replace />;
    }
  }

  return <>{children}</>;
}

export default RequireAuth;
